module.exports = __webpack_public_path__ + "img/Refit.95d567aa.jpeg";